module.exports = __webpack_public_path__ + "img/maropost-header-logo.5f860692.svg";